require('./prototype');
var Users       = require('./users');
var Locations   = require('./locations');
var Data        = require('./data');
var Utils       = require('./utils');
var NPS         = require('./nps');
var ReadOffline = require('./read-offline');
var Reader      = require('./reader');
var Modals      = require('./modals');
var VSTModals   = require('./vst-modals');
var CFI         = require('./cfi');
var Locale      = require('./locale');
var Color       = require('./color');
var Browser     = require('./browser');
var Calc        = require('./calc');
var Labs        = require('./labs');
var HolidayWatkins = require('./holiday-watkins');
import ifPhony from './phony';
import Fingerprint from './fingerprint';

var Helpers = {};

Helpers.Users       = Users;
Helpers.Locations   = Locations;
Helpers.Data        = Data;
Helpers.Utils       = Utils;
Helpers.NPS         = NPS;
Helpers.ReadOffline = ReadOffline;
Helpers.Reader      = Reader;
Helpers.Modals      = Modals;
Helpers.VSTModals   = VSTModals;
Helpers.CFI         = CFI;
Helpers.Locale      = Locale;
Helpers.Color       = Color;
Helpers.Browser     = Browser;
Helpers.Calc        = Calc;
Helpers.Labs        = Labs;
Helpers.HolidayWatkins = HolidayWatkins;
Helpers.ifPhony = ifPhony;
Helpers.Fingerprint = Fingerprint;

$.extend(Helpers, Users);
$.extend(Helpers, Locations);
$.extend(Helpers, Data);
$.extend(Helpers, Utils);
$.extend(Helpers, NPS);
$.extend(Helpers, ReadOffline);
$.extend(Helpers, Reader);
$.extend(Helpers, Modals);
$.extend(Helpers, VSTModals);
$.extend(Helpers, CFI);
$.extend(Helpers, Locale);
$.extend(Helpers, Color);
$.extend(Helpers, Browser);
$.extend(Helpers, Calc);
$.extend(Helpers, Labs);
$.extend(Helpers, HolidayWatkins);
$.extend(Helpers, ifPhony);
$.extend(Helpers, Fingerprint);

// Bind all events to support cross platform
Helpers.mouseMoveEvent = 'mousemove touchmove pointermove MSPointerMove';
Helpers.mouseDownEvent = 'mousedown touchstart pointerdown MSPointerDown';
Helpers.mouseUpEvent = 'mouseup touchend pointerup MSPointerUp';

module.exports = Helpers;
